import { Col, Row, Tooltip } from "antd";
import PaginationComponentListTodo001 from "../../../../../common/components/pagination/PaginationComponentListTodo001";
import TodoItem from "./TodoItem";
import { TodoTaskItem, TodoTaskList } from "../../entity/Entity";

type TodoListProps = {
  page: number;
  size: number;
  total: number;
  setPageSize: (val: number) => void;
  setPageNumber: (val: number) => void;
  todoTaskList: TodoTaskList;
  onClickTodo: (item: TodoTaskItem) => void;
};

export default function TodoList({
  page,
  size,
  total,
  setPageSize,
  setPageNumber,
  todoTaskList,
  onClickTodo,
}: TodoListProps) {
  return (
    <div className="td001-todo__list">
      <div style={{ flex: 1 }}>
        <Row gutter={[22, 22]} style={{ marginTop: 12 }}>
          {todoTaskList?.map((item) => {
            return (
              <Col
                style={{
                  alignItems: "stretch",
                  display: "flex",
                  flexBasis: "50%",
                }}
                span={12}
                flex={1}
                key={item.id}
              >
                <TodoItem onClickTodo={onClickTodo} item={item} />
              </Col>
            );
          })}
        </Row>
      </div>
      <div className="pm025-pagination">
        <PaginationComponentListTodo001
          total={total}
          page={page}
          size={size}
          setPage={setPageNumber}
          setSize={setPageSize}
        />
      </div>
    </div>
  );
}
